import { Component, Inject } from '@angular/core';
import { AuthGuardService, Producer } from '@sc/pas-common';
import { AuthService, ProducerService } from 'app/core/services';
import { RetirementInsuranceResponse } from './models/retirement-insurance-response.model';

@Component({
  selector: 'sc-retirement-insurance',
  templateUrl: './retirement-insurance.component.html',
  styleUrls: ['./retirement-insurance.component.scss']
})
export class RetirementInsuranceComponent {

  public producers: Producer[];
  public openMenu = false;
  public loading = false;

  constructor(
    private producerService: ProducerService,
    private authGuardService: AuthGuardService,
    private auth: AuthService,
    @Inject('Window') private window: any
  ) { }

  openPASSelector() {
    this.loading = true;
    this.producerService.getByUserID(this.authGuardService.user).subscribe(producers => {
      this.producers = producers;
      this.openMenu = true;
    });
  }

  handleOnClickPasSelector(producer) {
    this.openMenu = false;
    this.auth.generateRetirementInsuranceAccess(producer.cuit).subscribe(
      (response: RetirementInsuranceResponse) => {
        this.window.open(`${response.url}${response.jwt_token}`, '_blank');
      }).add(() => this.loading = false);
  }

  closeLateralMenu() {
    this.loading = false;
    this.openMenu = false;
  }

}
